import React from "react";
import { Fab, Paper } from "@material-ui/core/index";
import AddIcon from "@material-ui/icons/Add";
import ReportListItem from "./ReportListItem";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { prm } from "../../../mocks";
import paths from "../../../routes/paths";

export default function ReportList() {
  const classes = styles();
  const history = useHistory();

  const handleItemPress = (passenger) => {
    history.push({ pathname: paths.PRM_DETAILS, state: { passenger } })
  };

  return (
    <Paper className={classes.container} square elevation={0}>
      {prm.map((item, index) => (
        <ReportListItem
          key={index}
          passenger={item}
          greyBackground={index % 2 !== 0}
          onPress={handleItemPress.bind(this)}
        />
      ))}
      <div>
        <Fab
          color="primary"
          aria-label="add"
          className={classes.fab}
          onClick={() => history.push({ pathname: paths.PRM_CREATE })}
        >
          <AddIcon />
        </Fab>
      </div>
    </Paper>
  );
}

const styles = makeStyles(theme =>
  createStyles({
    container: {
      height: "100%",
      paddingBottom: 100,
      overflowY: "scroll"
    },
    fab: {
      margin: 0,
      top: "auto",
      right: 20,
      bottom: 20,
      left: "auto",
      position: "fixed"
    }
  })
);
